import styled from 'styled-components';
import { FormComponent } from '../../../components/form';

export const StyledFormComponent = styled(FormComponent)`
    margin: 0 auto;

    .form-submit-container {
        text-align: center;
        margin: 20px 0;
        .bt {
            width: 100%;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/authentication/staging/StagingLoginFormComponentStyle.js